const es = {
  singular: {
    'search': 'buscar',
    'filter': 'filtrar',
    'filter-by': 'filtrar por',
    'region': 'región',
    'experience': 'experiencia',
    'found': 'encontrado',
    'sort-by': 'ordenar por',
    'recommended': 'recomendado',
    'most-valued': 'mejor valorado',
    'cheapest-service': 'servicio más barato',
    'most-expensive-service': 'servicio más caro',
    'see': 'ver',
    'see-more': 'ver más',
    'see-less': 'ver menos',
    'see-options': 'ver opciones',
    'see-spas': 'ver spas',
    'XX-in-XX': '{{left}} en {{right}}',
    'coupon': 'cupón',
    'buy': 'comprar',
    'book': 'reservar',
    'continue': 'continuar',
    'back': 'atrás',
    'go-back': 'volver atrás',
    'hotel-kind': 'tipo de hotel',
    'cheapest-hotel': 'hotel más barato',
    'most-expensive-hotel': 'hotel más caro',
    'hotel-and-spa': 'hotel + spa',
    'other': 'otro',
    'remove': 'quitar',
    'apply': 'aplicar',
    'code': 'código',
    'remember-exc': '¡Recuerda!',
    'pay': 'pagar',
    'thanks': 'gracias',
    'here': 'aquí',
    'warning': 'alerta',
    'address': 'Dirección',
    'web-hosted-at': 'Web alojada por',
    'version': 'versión',
    'date': 'fecha',

    'christmas': 'navidad',
    'christmas-special': 'especial navidad',
    'christmas-and-couple': 'navidad + pareja',
    'christmas-and-food': 'navidad + comida',

    'valentines': 'Valentín',
    'saint-valentines': 'San Valentín',
    'valentines-special': 'Especial San Valentín',

    'go-to-XX': 'Ir a {{place}}',

    'loc-type-country': 'país',
    'loc-type-community': 'comunidad',
    'loc-type-district': 'distrito',
    'loc-type-parish': 'parroquia',
    'loc-type-region': 'provincia',
    'loc-type-city': 'ciudad',

    'gift-voucher': 'bono regalo',
    'show-all-photos': 'mostrar todas las fotos',
    'your-getaway-includes': 'tu escapada incluye',
    'no-availability-for-given-dates-and-pax': 'no tenemos disponibilidad para las fechas y la personas seleccionadas',
    'no-rates-for-given-dates-and-pax': 'no hay tarifas disponibles para esta configuración',
    'discount-for-time': 'descuento por tiempo limitado',
    'night': 'noche',
    'step-personal-data': 'Datos Personales',
    'step-payment-options': 'Opciones de pago',
    'no-refundable': 'no reembolsable',
    'no-refundable-get-away': 'No reembolsable. No se permiten cancelaciones ni cambios de fechas.',
    'no-changes-nor-cancel-allowed': 'No se permiten cancelaciones ni cambios de fechas',
    'refunds-label-date': 'Cancelación gratuita hasta el {{deadline}}, después tendrá un coste de {{price}}',
    'refunds-label-time':'Cancelación gratuita hasta las {{deadline}}, después tendrá un coste de {{price}}',

    'purchase-has-to-accept-conditions': 'Debes aceptar los términos y condiciones para poder continuar con tu proceso',

    'downloading-purchase-data': 'descargando los datos de su compra',
    'downloading-booking-data': 'Descargando los datos de su reserva',
    'confirming-voucher': 'estamos confirmando su bono.',
    'confirming-booking': 'estamos confirmando su reserva.',
    'voucher-confirm-takes-a-minute': 'esto puede llevar unos minutos, sé paciente.',

    'were-sorry': 'Lo sentimos.',
    'an-error-has-ocurred-contact-support': 'Ha ocurrido un error, por favor, póngase en contacto con nuestro servicio técnico',
    'apologise-for-inconvenience': 'Disculpe las molestias.',
    'you-can-try-again-here': 'puede volver a intentar su compra pulsando',

    'an-error-has-ocurred': '¡Ha ocurrido un error!',
    'the-purchase-could-not-be-started': 'No hemos podido inicar el proceso de compra.',
    'please-try-it-again-later': 'Por favor, inténtelo más tarde.',
    'if-problems-persist-contact-support': 'Si sigue teniendo problemas, póngase en contacto con nuestro servicio técnico',

    'booking-cannot-continue': 'No se pudo continuar con la reserva. Inténtelo más tarde',
    'booking-cannot-be-located-support': 'La reserva no pudo ser localizada. Por favor, contacte con nosotros y se lo solucionaremos en seguida',
    'booking-is-already-booked': 'Esta reserva ya ha sido confirmada.',

    'voucher-cannot-continue': 'No se pudo continuar con la compra. Inténtelo más tarde',
    'voucher-cannot-be-located-support': 'La venta no pudo ser localizada. Por favor, contacte con nosotros y se lo solucionaremos en seguida',
    'voucher-file-cannot-be-located-support': 'El bono no pudo ser localizado. Por favor, contacte con nosotros y se lo solucionaremos en seguida',

    'voucher-file-you-may-download': 'Si lo prefieres, puedes descargar directamente el bono:',
    'voucher-file-btn': 'Descargar el Bono en PDF',
    'voucher-file-btn-short': 'Descargar en PDF',

    'your-voucher-is-confirmed': 'Su bono ha sido confirmado con éxito',
    'you-will-receive-voucher-email': 'En breve recibirás el bono y el teléfono del spa para reservar cita en la dirección',
    'remember-voucher-at-spa': 'Recuerda que es necesario presentarlo en formato físico o digital.',
    'contact-support-with-any-question': 'Si tienes alguna pregunta, no dudes en contactarnos al email',
    'booking-get-your-bags-ready': 'Prepara las maletas porque vas a disfrutar de unos días increíbles en',
    'congratulations-XX': '¡Felicidades {{client}}!',

    'manage-voucher-title': 'Gestiona tu bono fácilmente',

    'manage-voucher-login-error-bad-spa-voucher-header': 'No hemos podido validar tus datos',
    'manage-voucher-login-error-bad-spa-voucher': '<p>Comprueba que la referencia del bono y la fecha de expiración estén correctas e inténtalo de nuevo.</p> <p>Si sigues teniendo problemas, puedes enviarnos un email a la siguiente dirección:</p>',
    'manage-voucher-login-error-bad-gift-voucher-header': 'Parece que has introducido una Tarjeta Regalo de Spalopia.com',
    'manage-voucher-login-error-bad-gift-voucher': '<p>Para canjearla tan solo tienes que llamar al spa que elijas y realizar la reserva. </p><p>En caso de tener dudas puedes ponerte en contacto con nosotros en el email:</p>',
    'manage-voucher-login-error-bad-booking-header': 'Parece que has introducido la referencia de una Reserva',
    'manage-voucher-login-error-bad-booking': 'Si necesitas ayuda con la misma, puedes enviarnos un email a la siguiente dirección de correo o ponerte en contacto directamente con el spa.',
    'manage-voucher-login-error-bad-external-voucher-header': 'Parece que has introducido una referencia que no pertenece a Spalopia.com',
    'manage-voucher-login-error-bad-external-voucher': '<p>Los bonos de Spalopia empiezan por <strong>SP</strong> o <strong>BOSPD</strong>. En caso de haber adquirido el bono en otra web y tener una duda, debes ponerte en contacto directamente con ellos.</p> <p>Para cualquier otra cosa relacionada con Spalopia.com puedes mandarnos un email a ayuda@spalopia.com y te atenderemos a la mayor brevedad.</p>',
    'manage-voucher-login-error-bad-other-voucher-header': 'Parece que la referencia introducida no existe',
    'manage-voucher-login-error-bad-other-voucher': '<p>Comprueba que empiece por <strong>SP</strong> o <strong>BOSPD</strong> para confirmar que sea de Spalopia.com.</p>En caso de tener alguna duda, puedes escribirnos a la siguiente dirección de email y te atenderemos a la mayor brevedad.',
    'manage-voucher-login-error-bad-get-away-header': 'Parece que has introducido la referencia de una Escapada',
    'manage-voucher-login-error-bad-get-away': 'Si necesitas ayuda con la reserva o tienes alguna duda, puedes enviarnos un email a la siguiente dirección de correo.',

    'manage-voucher-info-head': 'Personaliza, canjea o cambia tu bono:',
    'manage-voucher-info-list-1': 'Activa tu bono para poder canjearlo',
    'manage-voucher-info-list-2': 'Canjea tu bono y disfruta la experiencia',
    'manage-voucher-info-list-3': 'Edita el nombre del bono',
    'manage-voucher-info-list-4': 'Cancela si tiene menos de 14 días',
    'manage-voucher-info-list-5': 'Cambia el servicio por otro diferente',
    'manage-voucher-info-foot': 'Introduce tu email, referencia y fecha de validez',

    'manage-voucher-input-email': 'Email *',
    'manage-voucher-input-code': 'Referencia *',
    'manage-voucher-input-date': 'Fecha de validez *',
    'manage-voucher-login-btn': 'Continuar',
    'manage-voucher-date-error': 'La fecha de expiración no es correcta',
    'manage-voucher-code-error': 'El código del bono no es correcto',
    'manage-voucher-email-error': 'El email no es correcto',

    'manage-voucher-accept-offers': 'Quiero recibir promociones y descuentos.',

    'manage-voucher-faq-header': 'Preguntas frecuentes',

    'manage-voucher-form-header-title': '¡Genial! Ya has activado tu bono.',
    'manage-voucher-form-header-subtitle': 'Estás a punto de canjear tu bono',
    'manage-voucher-form-header-info': 'Haz clic en canjear bono para continuar y poder disfrutar de la experiencia.',

    'manage-voucher-form-gift': 'Regalo',
    'manage-voucher-form-code': 'Referencia',
    'manage-voucher-form-date': 'Expira',

    'manage-voucher-form-beneficiary': 'Beneficiario',
    'manage-voucher-form-purchase-info': 'Datos de compra',

    'manage-voucher-form-beneficiary-name': 'Nombre del beneficiario',
    'manage-voucher-form-buyer-name': 'Nombre del comprador',
    'manage-voucher-form-buyer-email': 'Email del comprador',
    'manage-voucher-form-buyer-payment-method': 'Método de pago',

    'manage-voucher-form-is-expired': 'El bono está caducado',
    'manage-voucher-form-is-cancelled': 'El bono está cancelado',
    'manage-voucher-form-is-cancelled-notice': 'Si tienes alguna duda al respecto, puedes escribirnos al Email:',

    'manage-voucher-form-actions-edit': 'Editar información del beneficiario',
    'manage-voucher-form-actions-redeem': 'Canjear bono',
    'manage-voucher-form-actions-cancel': 'Cancelar bono',
    'manage-voucher-form-actions-change': 'Cambiar por otro servicio',
    'manage-voucher-form-actions-extend': 'Ampliar fecha',

    'manage-voucher-form-actions-cancel-modal-title': '¡Estás a punto de cancelar tu bono!',
    'manage-voucher-form-actions-cancel-modal-body': 'Lamentamos que quieras cancelar tu bono. Puedes solicitar una devolución o recibir un cupón con el valor del bono para disfrutar mas adelante.',

    'manage-voucher-form-actions-service-change-modal-title': 'Estás a punto de cambiar el servicio de tu bono',

    'manage-voucher-form-actions-extend-modal-title': 'Estás a punto de ampliar las fechas de tu bono',

    'manage-voucher-form-actions-extend-modal-body-0': '¡Pero no te preocupes!',
    'manage-voucher-form-actions-extend-modal-body-1': 'Normalmente los spas dan entre 6 y 12 meses de caducidad para canjear los bonos pero <strong>con Spalopia los bonos no caducan.</strong>',
    'manage-voucher-form-actions-extend-modal-body-2': 'Si cuando vayas a canjearlo el spa te indica que no es posible usarlo, ponte de nuevo en contacto con nosotros pudiendo proceder a:',
    'manage-voucher-form-actions-extend-modal-body-3': ' - Recibir un nuevo bono para este spa (si el precio del nuevo servicio es mayor solamente necesitaríamos que nos abonaras la diferencia por transferencia bancaria)',
    'manage-voucher-form-actions-extend-modal-body-4': ' - Recibir una tarjeta regalo canjeable en cualquiera de los spas que ofrecemos a través de nuestra web.',
    'manage-voucher-form-actions-extend-modal-body-5': 'En cualquier caso, escríbenos un email al siguiente email y te ayudamos para que puedas disfrutar de la experiencia.',

    'manage-voucher-form-actions-redeem-expired-modal-body-0': 'Si cuando vayas a canjearlo el spa te indica que no es posible usarlo, ponte de nuevo en contacto con nosotros pudiendo proceder a:',
    'manage-voucher-form-actions-redeem-expired-modal-body-3': 'En cualquier caso, escríbenos al siguiente email y te ayudamos para que puedas disfrutar de la experiencia.',

    'manage-voucher-form-actions-redeem-modal-title': 'Ya puedes canjear tu bono',
    'manage-voucher-form-actions-redeem-modal-body-spa-name-a': 'Solo tienes que contactar con',
    'manage-voucher-form-actions-redeem-modal-body-spa-name-b': 'e indicar el número de referencia.',

    'manage-voucher-form-actions-how-to-contact': 'Cómo contactar:',
    'manage-voucher-form-actions-how-to-contact-email': 'Envía un email a',
    'manage-voucher-form-actions-how-to-contact-phone': 'Llama al',
    'manage-voucher-form-actions-how-to-contact-web': 'Reserva directamente en el spa',

    'redeem-get-away-header-title': '¿Cómo puedo canjear mi escapada de Hotel + Spa?',
    'redeem-get-away-info-1': 'Las fechas de estancia ya están confirmadas con el hotel y no tienes que hacer nada. Tan solo ir al Hotel en la fecha seleccionada con tu DNI y tu email para hacer el check-in de entrada.',
    'redeem-get-away-info-2': 'Por otro lado, para disfrutar de la experiencia en el Spa es necesario que te pongas en contacto previamente con el centro para realizar la reserva de los servicios.',

    'redeem-get-away-subtitle': 'A continuación te contamos cómo solicitar la reserva de fecha con el Spa:',

    'redeem-get-away-step-1-header': 'Paso 1:',
    'redeem-get-away-step-1-body': 'En el email de confirmación de compra tienes un PDF adjunto con toda la información. Busca el número de referencia de tu bono para ir al Spa antes de llamarlos. Si no sabes dónde encontrarlo, haz click',

    'redeem-get-away-step-2-header': 'Paso 2:',
    'redeem-get-away-step-2-body': 'Una vez identificado el localizador, solo tienes que llamar al centro y reservar informando que tienes un bono de Spalopia con las fechas seleccionadas para la estancia. Te pedirán el número de referencia del bono y te buscarán el mejor hueco en su agenda para disfrutar del servicio de Spa durante tu estancia.',
    'redeem-get-away-step-2-body-extra': 'Los datos de contacto del Spa lo tienes en el email de compra, así como en el Bono en PDF adjunto.',

    'newsletter-posible-discount': 'Recibe un código de descuento del 5% para tu primera compra:',
    'newsletter-sub-pls': 'Suscríbete a nuestra Newsletter para obtener el descuento',
    'newsletter-sub-notice': 'No aplica en servicios con descuentos ni en Escapadas Wellness',
    'newsletter-country-selector': 'seleccionar país',
    'newsletter-btn': 'Obtener descuento',

    'newsletter-subscribed': 'Gracias por suscribirte a nuestro newsletter!',
    'newsletter-subscribed-secondary': 'En breve recibirás tu código de descuento en tu email.',
    'newsletter-error': 'No hemos podido registrar los datos. Disculpe las molestias',

    'legal-notice-title': 'Aviso Legal',

    'legal-notice-0-header': '1. Objeto y aceptación',
    'legal-notice-0-body-0': 'El presente aviso legal regula el uso del sitio Web: <strong>www.spalopia.com</strong>',
    'legal-notice-0-body-1': 'El sitio web <strong>www.spalopia.com</strong> presta servicios cuyo objetivo primordial es permitir el contacto entre los usuarios y la empresa, bien para ponerse en contacto con nosotros o para pedir presupuestos.',
    'legal-notice-0-body-2': 'La navegación por la página <strong>www.spalopia.com</strong> atribuye la condición de usuario de la misma e implica la aceptación plena y sin reservas de todas y cada una de las disposiciones incluidas en este Aviso Legal, que pueden sufrir modificaciones.',
    'legal-notice-0-body-3': 'El usuario se obliga a hacer un uso correcto del sitio Web de conformidad con las leyes, la buena fe, el orden público, los usos del tráfico y el presente Aviso Legal. El Usuario responderá frente a <strong>SPALOPIA, S.L.</strong> y frente a terceros, de los daños y perjuicios que pudieran causarse como consecuencia del incumplimiento de dicha obligación.',

    'legal-notice-1-header': '2. Titularidad de la web e identificación del Prestador de Servicios de la Sociedad de la Información',
    'legal-notice-1-body-0': 'Con la finalidad de dar cumplimiento al principio de Información general exigido por el Artículo 10 de la Ley 34/2002, de 11 de julio, de servicios de la sociedad de la información y de comercio electrónico  informamos a nuestros usuarios que el presente sitio web pertenece a  <strong>SPALOPIA, S.L.</strong> con cif B76681568, inscrita en el Registro Mercantil de Santa Cruz de Tenerife en la hoja TF-55873, Folio 161 del tomo 3399 de la Sección I.',

    'legal-notice-2-header': '3. Condiciones generales de acceso y utilización',
    'legal-notice-2-body-0': 'El sitio Web y sus servicios son de acceso libre y gratuito, si bien la utilización de determinadas áreas o servicios está condicionada a cumplimentar formularios de recogida de datos. Sólo los mayores de 18 años podrán facilitar datos a través de nuestra web, y los menores de 16 años no pueden facilitarlos sin el consentimiento de los padres o tutores.',
    'legal-notice-2-body-1': 'El Usuario garantiza la autenticidad y actualidad de todos aquellos datos que comunique a <strong>SPALOPIA, S.L.</strong> y será el único responsable de las manifestaciones falsas o inexactas que realice.',
    'legal-notice-2-body-2': '<strong>www.spalopia.com</strong> tiene los siguientes tipos de usuarios:',
    'legal-notice-2-body-3': 'Usuarios que aportan datos en cualquiera de los formularios disponibles: Los datos personales que <strong>SPALOPIA, S.L.</strong> solicita incluye el nombre y dirección electrónica y los proporcionados por el propio usuario al rellenar los formularios.',
    'legal-notice-2-body-4': 'Usuarios que no han contactado con <strong>SPALOPIA, S.L.</strong> pero de los que se recogen datos: Datos proporcionados por las cookies',

    'legal-notice-3-header': '3.1. Reglas y prohibiciones de uso para usuarios de nuestros servicios',
    'legal-notice-3-body-0': 'El Usuario se compromete expresamente a hacer un uso adecuado de los contenidos y servicios ofrecidos y a no emplearlos para:',
    'legal-notice-3-body-1': 'Difundir contenidos delictivos, violentos, pornográficos, racistas, xenófobo, ofensivos, de apología del terrorismo o, en general, contrarios a la ley o al orden público.',
    'legal-notice-3-body-2': 'Introducir en la red virus informáticos o realizar actuaciones susceptibles de alterar, estropear, interrumpir o generar errores o daños en los documentos electrónicos, datos o sistemas físicos y lógicos de <strong>SPALOPIA, S.L.</strong> o de terceras personas; así como obstaculizar el acceso de otros Usuarios al sitio Web y a sus servicios.',
    'legal-notice-3-body-3': 'Intentar acceder a áreas restringidas de los sistemas informáticos de <strong>SPALOPIA, S.L.</strong> o de terceros y, en su caso, extraer información.',
    'legal-notice-3-body-4': 'Vulnerar los derechos de propiedad intelectual o industrial, así como violar la confidencialidad de la información de <strong>SPALOPIA, S.L.</strong> o de terceros.',
    'legal-notice-3-body-5': 'Suplantar la identidad de otro Usuario, de las administraciones públicas o de un tercero.',
    'legal-notice-3-body-6': 'Reproducir, copiar, distribuir, poner a disposición o de cualquier otra forma comunicar públicamente, transformar o modificar los Contenidos, a menos que se cuente con la autorización del titular de los correspondientes derechos o ello resulte legalmente permitido',
    'legal-notice-3-body-7': 'Recabar datos con finalidad publicitaria y de remitir publicidad de cualquier clase y comunicaciones con fines de venta u otras de naturaleza comercial sin que medie su previa solicitud o consentimiento.',

    'legal-notice-4-header': '3.2. Procedimiento en caso de realización de actividades de carácter ilícito',
    'legal-notice-4-body-0': 'En el caso de que cualquier usuario o un tercero considere que existen hechos o circunstancias que revelen el carácter ilícito de la utilización de cualquier contenido y/o de la realización de cualquier actividad en las páginas Web incluidas o accesibles a través del sitio Web, deberá enviar una notificación a <strong>SPALOPIA, S.L.</strong> identificándose debidamente, especificando las supuestas infracciones y declarando expresamente y bajo su responsabilidad que la información proporcionada en la notificación es exacta.',

    'legal-notice-5-header': '4. Política de privacidad',
    'legal-notice-5-body-0': 'El usuario puede consultar cómo <strong>SPALOPIA, S.L.</strong> utiliza sus datos y las medidas de seguridad implantadas en el siguiente enlace:',

    'legal-notice-6-header': '5. Política de cookies',
    'legal-notice-6-body-0': '<strong>SPALOPIA, S.L.</strong> instala cookies en el ordenador del usuario. Para conocer más las cookies de nuestro sitio web acuda al siguiente enlace:',

    'legal-notice-7-header': '6. Notificaciones',
    'legal-notice-7-body-0': 'Todas las notificaciones y comunicaciones entre los usuarios y <strong>SPALOPIA, S.L.</strong> se considerarán eficaces, a todos los efectos, cuando se realicen a través de correo postal o correo electrónico o comunicación telefónica. Los usuarios deberán dirigirse a <strong>SPALOPIA, S.L.</strong> mediante:',
    'legal-notice-7-body-1': 'Envío por correo postal a la siguiente dirección:',
    'legal-notice-7-body-2': 'Envío por correo electrónico a la siguiente dirección: ',

    'legal-notice-8-header': '7. Propiedad Industrial y propiedad intelectual',
    'legal-notice-8-body-0': 'Todos los contenidos del sitio Web, como textos, fotografías, gráficos, imágenes, iconos, tecnología, software, así como su diseño gráfico y códigos fuente, constituyen una obra cuya propiedad pertenece a <strong>SPALOPIA, S.L.</strong>, sin que puedan entenderse cedidos al Usuario ninguno de los derechos de explotación sobre los mismos más allá de lo estrictamente necesario para el correcto uso de la Web.',
    'legal-notice-8-body-1': 'En definitiva, los usuarios que accedan a este sitio Web pueden visualizar los contenidos y efectuar, en su caso, copias privadas autorizadas siempre que los elementos reproducidos no sean cedidos posteriormente a terceros, ni se instalen a servidores conectados a redes, ni sean objeto de ningún tipo de explotación y única y exclusivamente mientras se encuentre en vigor el servicio.',
    'legal-notice-8-body-2': 'Asimismo, todas las marcas, nombres comerciales o signos distintivos de cualquier clase que aparecen en el sitio Web son propiedad de <strong>SPALOPIA, S.L.</strong>, sin que pueda entenderse que el uso o acceso al mismo atribuya al Usuario derecho alguno sobre los mismos.',
    'legal-notice-8-body-3': 'Quedan prohibidas la distribución, modificación, cesión o comunicación pública de los contenidos y cualquier otro acto que no haya sido expresamente autorizado por <strong>SPALOPIA, S.L.</strong> En caso de incumplimiento <strong>SPALOPIA, S.L.</strong> procederá a adoptar las medidas legales oportunas.',

    'legal-notice-9-header': '8. Exención de responsabilidad y modificación del presente aviso legal',
    'legal-notice-9-body-0': 'La información que se difunde en esta web se hace única y exclusivamente a título informativo, reservándose <strong>SPALOPIA, S.L.</strong> el derecho de eliminar o suspender su difusión, total o parcialmente, y a modificar la estructura y contenido de este sitio Web sin aviso previo, pudiendo incluso limitar o no permitir el acceso a dicha información. <strong>SPALOPIA, S.L.</strong>intenta  mantener la calidad y actualización de esta información y evitar y minimizar posibles errores pero <strong>SPALOPIA, S.L.</strong> no responderá de los daños o perjuicios causados por decisiones tomadas en base a la información difundida; ni de inexactitudes, omisiones o errores contenidos en el mismo, ni de los problemas que se originen por el uso de este sitio Web u otro de conexión externa; ni de los daños y/o perjuicios en el software o hardware del usuario que se deriven del acceso a este sitio Web.',
    'legal-notice-9-body-1': 'Los Usuarios aceptan expresamente que <strong>SPALOPIA, S.L.</strong>  no será responsable del acceso no autorizado o alteración de sus transmisiones o datos, de cualquier material o datos enviados o recibidos o no enviados o recibidos, ni de ninguna transacción realizada a través de su web.',
    'legal-notice-9-body-2': '<strong>SPALOPIA, S.L.</strong> se reserva el derecho a modificar el presente aviso legal unilateralmente y sin preaviso  en los términos y condiciones que estime conveniente con la única obligación de informar al usuario de las modificaciones efectuadas a través de www.spalopia.com',

    'legal-notice-10-header': '9. Nulidad parcial',
    'legal-notice-10-body-0': 'Si alguna de las presentes cláusulas fuese declarada nula y sin efecto por resolución firme dictada por autoridad competente, los restantes términos y condiciones permanecerán en vigor, sin que queden afectados por dicha declaración de nulidad.',

    'legal-notice-11-header': '10. Ley aplicable y tribunales competentes',
    'legal-notice-11-body-0': 'El presente sitio web queda sometido a lo establecido por la legislación española y normativa europea que resulte de aplicación',
    'legal-notice-11-body-1': 'Cualquier controversia que surja o guarde relación con el uso de la página web o con dichos productos será sometida a la jurisdicción no exclusiva de los juzgados y tribunales españoles de la provincia de S/C de Tenerife.',
    'legal-notice-11-body-2': 'Si se trata de un consumidor final nada en la presente cláusula afectará a los derechos que como tal le reconoce la legislación vigente, pudiendo elegir presentar una reclamación para hacer valer sus derechos en relación con las presentes Condiciones ante el Juez o Tribunales que correspondan a su domicilio.',

    'payment-method': 'método de pago',
    'credit-card-payment': 'Pagar con tarjeta de crédito',
    'paypal-payment': 'Pagar con Paypal',
    'paypal-multibanco-payment': 'Pagar con Multibanco',
    'paypal-applepay-payment': 'Pagar con Apple Pay',
    'all-transtactions-are-safe': 'Todas las transacciones hechas en este sitio son seguras',
    'credit-card-data-errors': 'Ha habido algún error con los datos de la tarjeta, por favor, inténtelo de nuevo.',
    'to-try-it-again': 'Para volver a intentarlo',
    'click-here': 'pulse aquí',

    'name': 'nombre',
    'surname': 'apellidos',
    'email': 'email',
    'confirm-email': 'confirmar email',
    'phone': 'teléfono',
    'name-and-surname': 'nombre y apellidos',

    'offer-accept-label': 'Acepto recibir información y ofertas en mi email.',

    'ive-read-and-accept': 'He leído y acepto los ',
    'and the': ' y los ',

    'service-terms-and-conditions': 'términos y condiciones del servicio',
    'terms-and-conditions': 'términos y condiciones',
    'hotel-spa-terms-and-conditions': 'Términos y condiciones del Hotel y Spa',

    'buyer-form-name-and-surname-error': 'El nombre y apellidos no son correctos',
    'buyer-form-name-error': 'El Nombre no es correcto ',
    'buyer-form-surname-error': 'Los Apellidos no son correctos ',
    'buyer-form-email-error': 'El Email no es correcto',
    'buyer-form-phone-error': 'El Número de teléfono no es correcto',
    'buyer-form-terms-error': 'Ha de aceptar los términos y condiciones',
    'newsletter-form-location-error': 'La localización no es válida',

    'if-thereis-coupon-applies-next-step': 'Si tiene un código de descuento se aplica en el siguiente paso.',

    'i-have-discount-coupon': 'Tengo un código de descuento',
    'coupon-XX-applied': 'Cupón "{{label}}" aplicado',
    'coupon-XX-applied-with-XX-value': '¡Código "{{label}}" con descuento del {{discount}}% aplicado correctamente!',

    // Se usan para traducir los horarios del spa.
    'lunes': 'lunes',
    'martes': 'martes',
    'miercoles': 'miércoles',
    'jueves': 'jueves',
    'viernes': 'viernes',
    'sabado': 'sábado',
    'domingo': 'domingo',
    'festivo': 'festivo',

    'special-conditions': 'Condiciones especiales',

    'hotels-with-spa': 'hoteles con spa',

    'from-value': 'desde',

    'select-price': 'selecciona un importe',

    'minute': 'minuto',

    'environment': 'ambiente',
    'service': 'servicio',
    'attention': 'atención',
    'quality-price': 'calidad-precio',
    'comment': 'comentario',

    'the-spa': 'el spa',
    'the-hotel': 'el hotel',

    'you-will-find-in-XX': 'Vas a encontrar en {{spaName}}',

    'send': 'enviar',
    'sent-comment': 'comentario enviado',

    'reviews-last': 'Últimas valoraciones',
    'reviews-add': 'Agregar valoración',
    'reviews-empty': 'No hay valoraciones recientes',

    'description': 'descripción',

    'unique-benefits': 'Beneficios únicos',

    'enjoy-once-is-open': 'disfrútalo cuando reabra',
    'enjoy-once-spa-is-open': 'disfrútalo cuando reabra el spa',
    'couple': 'pareja',
    'couple-special': 'especial pareja',
    'included-in-service': 'este servicio incluye',
    'included-in-XX-min-service': 'este servicio de {{time}} min incluye',
    'your-dates': 'Tus fechas',

    'is-gift-voucher-available': 'bonos regalo disponibles',
    'available-service': 'servicio disponible',
    'available-service-in-category': 'servicio disponible en categoría',
    'service-for': 'servicio para',
    'service-duration': 'duración del servicio',

    'spa-status-online': 'Spa Abierto',
    'spa-status-disabled': 'Spa desactivado',
    'spa-status-closed': 'Spa cerrado',
    'spa-status-closedtemp': 'Spa cerrado por temporada',
    'spa-status-lost': 'Spa perdido',

    'no-available-services': 'no se econtraron Servicios disponibles',
    'no-available-services-secondary': 'en este momento no podemos ofrecerte ningún servicio con los filtros seleccionados',

    'no-available-treatments': 'no se econtraron Tratamientos disponibles',
    'no-available-treatments-secondary': 'en este momento no podemos ofrecerte ningún tratamiento con los filtros seleccionados.',

    'no-available-promotions': 'No se econtraron Promociones Disponibles',
    'no-available-promotions-secondary': 'En este momento no podemos ofrecerte ninguna promoción con los filtros seleccionados.',

    'no-available-spas': 'No se encontraron Spas Disponibles',
    'no-available-spas-secondary': 'En este momento no podemos ofrecerte ningún spa con los filtros seleccionados.',

    'no-available-get-away': 'No se econtraron Escapadas Disponibles',
    'no-available-get-away-secondary': 'En este momento no podemos ofrecerte ninguna Escapada con los filtros seleccionados.',

    'no-available-get-away-availability': 'No se encontraron Escapadas disponibles para las fechas:',
    'no-available-get-away-availability-secondary': 'Por favor, seleccione otras fechas',

    'spa-schedule': 'Horarios del spa',

    'services-and-treatments': 'servicios y tratamientos',

    'summary-spa-closedtemp': 'Spa cerrado por temporada. Disfruta del bono cuando reabra el spa.',
    'summary-voucher-pdf': 'Recibes el bono en PDF y el teléfono para reservar cita.',
    'summary-change-refund': 'Cambios y devoluciones hasta 14 días después de la compra.',
    'summary-change-refund-chrst': 'Cambios y devoluciones hasta el 20 de enero.',
    'summary-expiration': 'Si caduca, cambiamos por tarjeta regalo de igual valor.',
    'summary-service-unavailable': 'Servicio no disponible',
    'summary-voucher-expirate-month': 'Canjeable durante los próximos {{months}} meses.',
    'summary-voucher-expirate-day': 'Canjeable durante los próximos {{days}} días.',

    'footer-company-code': 'Le comunicamos que el código de identificación asignado a dicha actividad es el',
    'contact-us': '¡Contáctanos!',
    'spa-gift-voucher': 'Bonos Regalos de Spa',
    'stay': 'estancia',
    'receive-offers': '¡Recibe las mejores oportunidades para su descanso en tu Email!',
    'search-spas': 'Buscar spas',

    'only-hotel': 'solo hotel',
    'person': 'persona',
    'destination': 'Destino',
    'departure': 'llegada',
    'arrive': 'salida',
    'treatment': 'tratamiento',
    'promotion': 'promoción',
    'massage': 'masaje',
    'hydrotherapy': 'hidroterapia',
    'ritual': 'ritual',
    'food': 'comida',
    'hotel': 'hotel',
    'offer': 'oferta',
    'booking': 'reserva',
    'online-booking': 'reserva online',
    'no-spa': 'sin spa',

    'booking-for': 'reserva para {{label}}',

    'treatment-in': 'tratamiento en {{location}}',

    'get-away-if-you-want-more-people': 'Si quieres buscar más de 2 personas, puedes usar el buscador general o entrar al detalle de una escapada',
    'get-away-you-can-modify': 'Puedes personalizar tu Escapada',
    'get-away-price-for': 'Precios para las fechas',
    'get-away-no-availability-for-dates': 'No hay escapadas disponibles para las fechas',
    'search-other-date': 'Buscar otra fecha',
    'search-by-date': 'Buscar por fecha',
    'search-for-two': 'Búsqueda para 2 personas',

    'no-search-results-for-XX': 'No hay resultados para la búsqueda:',
    'no-search-results-alternatives': 'Aquí tenemos otros resultados similares a tu búsqueda',

    'escapada': 'escapada',
    'spa': 'spa',

    'are-you-spa': '¿Eres un spa?',

    'mothers-day': 'Día de la Madre',
    'fathers-day': 'Día del Padre',

    'gift-card': 'Tarjetas Regalo',
    'gift-card-1': 'Bienestar de ensueño 25€',
    'gift-card-2': 'Relax sublime 50€',
    'gift-card-3': 'Oasis Deluxe 80€',
    'gift-card-4': 'Experiencia Sensorial 100€',
    'gift-card-5': 'Capricho Eterno 120€',

    'special-moments': 'Momentos Especiales',
    'special-moments-1': 'Circuito Spa',
    'special-moments-2': 'Spa en Pareja',
    'special-moments-3': 'Spa & Gastro',
    'special-moments-4': 'Circuito Spa & Masaje',
    'special-moments-5': 'Circuito Spa & Ritual',
    'special-moments-6': 'Spa Privado',
    'special-moments-7': 'Spa para Niños',
    'special-moments-8': 'Daypass en Spa',
    'special-moments-9': 'Spa para embarazadas',

    'treatment-1': 'Tratamientos faciales',
    'treatment-2': 'Tratamientos corporales',
    'treatment-3': 'Rituales de Belleza',

    'about-us': 'Sobre Nosotros',
    'about-us-1': 'Quienes somos',
    'about-us-2': 'Aviso legal',
    'about-us-3': 'Política de Privacidad',
    'about-us-4': 'Política de Cambios y Devoluciones',
    'about-us-5': 'Condiciones Generales de Compra',
    'about-us-6': 'Política de cookies',
    'about-us-7': 'Blog',
    'about-us-8': 'Contacto',

    'see-privacy-policy': 'Ver política de privacidad',
    'privacy-policy': 'Política de privacidad',
    'cookies-policy': 'Política de cookies',

    'old-redeem-voucher': 'Canjear Bono',
    'redeem-voucher': 'Gestiona tu Bono',

    'relax': 'relaja',
    'connect': 'conecta',
    'share': 'comparte',

    'checkout-voucher-header-title': '¿Listo para disfrutar del Bienestar?',
    'checkout-getaway-header-title': '¿Listo para disfrutar tu Viaje?',

    'checkout-voucher-form-title': 'Completa datos de la compra',
    'checkout-getaway-form-title': 'Completa datos de la reserva',
    'checkout-getaway-gift-title': '¿Es para regalo?',
    'checkout-getaway-gift-form-header':'¿Para quién es el Bono?',

    'search-by-location-or-spa': 'Busca por Nombre de Ciudad o del Spa',
    'search-by-destination': 'Buscar por destino',
    'search-by-treatment': 'Busca por Tratamiento',

    'benefits-givings': 'El mejor regalo para el descanso y la salud',
    'benefits-givings-small': 'El mejor regalo',
    'benefits-best-price': 'El precio garantizado',
    'benefits-safe-payment': 'Pago seguro',
    'benefits-save-time': 'Compra ahorrando tiempo',
    'benefits-give-experiencies': 'Regala experiencias',
    'benefits-valid-bonuses': 'Bonos siempre válidos',
    'benefits-support': '¿Tienes alguna duda?',
    'benefits-ssl': 'Encriptación SSL Protegida',
    'benefits-safe-payment-ensured': 'Pago seguro Garantizado',

    'benefits-desc-save-time': 'Sin colas ni esperas en centros Comerciales',
    'benefits-desc-give-experiencies': 'Los objetos acaban en el olvido, las experiencias son para siempre',
    'benefits-desc-valid-bonuses': 'Si caducan te lo cambiamos por un servicio de igual valor que tu elijas',
    'benefits-desc-support': 'Escríbenos a ayuda@spalopia.com',

    'promotion-home-desc': 'Encuentra las mejores experiencias de Spa en España: Circuito Spa, Spa y Masaje, Spa y Brunch, Spa y Hotel... ¡Todo lo que necesitas para descansar!',

    'home-header-title': 'ENCUENTRA LOS MEJORES BALNEARIOS Y SPAS',
    'home-header-subtitle': 'Busca experiencias de relax y bienestar para disfrutar con tus seres queridos en más de 300 spas de toda España',

    'home-promo-title': 'EVITA LA VUELTA A LA RUTINA',
    'home-promo-subtitle': '¡Aprovecha para relajarte con un Day Pass antes de que cambie el tiempo!',
    'home-promo-extra-1': 'Pasa el día completo en las instalaciones del Hotel',

    'home-promo-btn-label': 'Ver opciones Day Pass',

    'home-promo-side-title': 'Disfruta de las instalaciones del Hotel y del Spa sin alojarte',
    'home-promo-side-subtitle': '¡Día completo de relax!',

    'home-promo-section-1-title': 'Los mejores momentos para regalar y disfrutar',
    'home-promo-section-1-text': 'En Spalopia hemos hecho una selección de momentos especiales en el Spa para que puedas regalarlo o disfrutarlo y volver relajarte como te mereces.',
    'home-promo-section-2-title': 'Los mejores Tratamientos para ti',
    'home-promo-section-2-text': '¿Sabías que en el Spa hay mucho más que circuitos termales? Hemos seleccionado los mejores tratamientos para que disfrutes, desconectes, te relajes y recuperes energías con un masaje a 4 manos, una chocolaterapia o una envoltura de algas.',
    'home-promo-section-3-title': 'Momentos únicos para ti y los tuyos',
    'home-promo-section-3-text': 'Hay momentos que se merecen un ratito de relajación y bienestar. Por ello hemos realizado una selección de momentos únicos que te proponemos para que te dediques un ratito especial para ti y tus seres queridos.',
    'home-promo-section-4-title': 'Experiencias inolvidables en los mejores Spa',
    'home-promo-section-4-text': '¿Sabías que en Spalopia tienes más de 300 spas para disfrutar en toda España y Portugal? Aquí tienes una selección de las provincias e islas favoritas de nuestros clientes para ir al Spa.',
    'home-promo-section-5-text': '¿Quiere disfrutar de una experiencia única de bienestar y relajación en los balnearios de Portugal? He aquí una selección de las ciudades y barrios favoritos de nuestros clientes para ir de balneario en Portugal.',

    'home-promo-valentines-title': '¡FEBRERO EL MES DEL AMOR!',
    'home-promo-valentines-subtitle': 'Se acerca San Valentín y en Spalopia hemos seleccionado los mejores packs para sorprender a tu pareja',
    'home-promo-valentines-extra-1': '¡Elige entre Spa Privado, Masaje en Pareja, Escapadas o Circuito spa!',
    'home-promo-valentines-btn-label': 'Ver opciones de San Valentín',
    'home-promo-valentines-side-title': 'Dedica a tu pareja lo más preciado que tienes: Tiempo de calidad',
    'home-promo-valentines-side-subtitle': '¡Más de 500 opciones para elegir!',

    'home-promo-fathers-day-title': '¡PAPÁ SE MERECE UN DECANSO!',
    'home-promo-fathers-day-subtitle': 'Se acerca el Día del Padre y qué mejor regalo que dedicarle un ratito de paz y tranquilidad en el Spa.',
    'home-promo-fathers-day-extra-1': '¡Puedes elegir entre Circuito Spa, Masajes y mucho más!',
    'home-promo-fathers-day-btn-label': 'Ver opciones de Día del Padre',
    'home-promo-fathers-day-side-title': '¿Te imaginas su cara de felicidad mientras desconecta?',
    'home-promo-fathers-day-side-subtitle': '¡Y mejor si lo disfruta contigo!',

    'home-promo-mothers-day-title': 'SE ACERCA EL DÍA DE LA MADRE MÁS ESPECIAL',
    'home-promo-mothers-day-subtitle': 'Sorpréndela con un regalo original, especial...<br>¡Tiempo para ella!',
    'home-promo-mothers-day-extra-1': 'Hemos reunido las mejores experiencias de spa para que este año aciertes seguro.',
    'home-promo-mothers-day-btn-label': 'Ver los mejores regalos para Mamá',
    'home-promo-mothers-day-side-title': 'Un regalo inolvidable que dice<br> "te mereces un descanso"',
    'home-promo-mothers-day-side-subtitle': '¡Se lo merece!',

    'home-promo-holy-week-title': 'Escápate o quédate… pero desconecta esta Semana Santa',
    'home-promo-holy-week-subtitle': 'Esta Semana Santa elige desconectar de verdad.',
    'home-promo-holy-week-extra-1': 'Spa, bienestar y desconexión... a un clic.',
    'home-promo-holy-week-btn-label': 'Encontrar Spa para Semana Santa',
    'home-promo-holy-week-side-title': 'Playa, montaña... ¿o mejor spa? ',
    'home-promo-holy-week-side-subtitle': '¡Te lo mereces!',

    'get-away-landing-description-1': 'Descubre las mejores Escapadas románticas en hoteles con spas {{location}}. Tenemos una amplia selección de Escapadas para disfrutar y desconectar en pareja.',
    'get-away-landing-description-2': 'Realiza tu reserva online al mejor precio y vive una experiencia wellness única.',
    'get-away-landing-description-3': 'Hemos seleccionado para ti las mejores Escapadas {{location}} con servicios de Spa, circuito wellness, masajes y rituales de belleza incluidos. Queremos que encuentres la calma y armonía que tanto necesitas junto a tu pareja. Descubre un mundo de sensaciones nuevas en estos completos oasis de bienestar.',
    'get-away-landing-description-4': 'Experiencias románticas en pareja {{location}}. Hoteles de 4* y 5* con media pensión, masajes relajantes, jacuzzis de burbujas, circuitos termales de chorros que les dejarán como nuevos, jacuzzis de burbujas, saunas y baños turco para eliminar toxinas del organismo y fabulosos tratamientos faciales y corporales para limpiar e hidratar la piel al máximo.',
    'get-away-landing-description-5': 'Elige la mejor escapada en pareja en los mejores hoteles con Spa {{location}} y disfruta de la experiencia para desconectar al máximo.',

    'footer-description': 'En Spalopia encontrarás los mejores precios para disfrutar de una experiencia inolvidable en el Spa y centros wellness. Masajes, Rituales, Chocolaterapias, Dayspas, Spa con estancia o Spa con Brunch son algunos de los servicios y tratamientos que podrás seleccionar en los más de 300 spas y centros que trabajan con nosotros alrededor de toda España. Si ya sabes cuando quieres ir al Spa, puedes reservar directamente la fecha y la hora que más te interesa para planificar tu bienestar de una manera sencilla y cómoda con Spalopia. Tenemos miles de ofertas y promociones de Spa para ti y contamos con una gran variedad de servicios disponibles para regalar a tu ser querido a un precio único. Todos nuestros bonos y reservas de tratamientos de spas tienen la seguridad y confianza respaldada por Spalopia, la única web en toda España que tiene el objetivo de mejorar tu bienestar en el Spa.',
  },
  plural: {
    'hotel': 'hoteles',
    'ritual': 'rituales',
    'coupon': 'cupones',

    'description': 'descripciones',

    'christmas': 'navidad',

    'couple-special': 'especial parejas',
    'available-service': 'servicios disponibles',
    'available-service-in-category': 'servicios disponibles en categorías',
    'service-for': 'servicios para',

    'treatment-in': 'tratamientos en {{location}}',

    'promotion': 'promociones',

    'recommended': 'recomendados',
  },
}

export default es
